const accessToken =
  `Bearer ${localStorage.getItem("auth")}`
export default accessToken
